import axiosTouri from "../../axiosTuri";

// Get All Driver Reservation
export const getAllDriverResrtvation = async () => {
  const res = await axiosTouri.get(`driver-reservations`);
  if (res.data.status == "success") {
    return res.data;
  }
};
